export default __webpack_public_path__ + "static/media/login-button.48ff89f9.svg";